import styled from 'styled-components'

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.75rem;
`

export const SectionLabel = styled.span`
  font-size: 0.82rem;
  font-weight: 600;
  color: #374151;
`

export const DropZone = styled.div<{ isDragActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 2px dashed ${({ isDragActive }) => (isDragActive ? '#0090D3' : '#e5e7eb')};
  border-radius: 0.75rem;
  padding: 0.875rem 1rem;
  background: ${({ isDragActive }) => (isDragActive ? '#E6F4FB' : '#ffffff')};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #0090D3;
    background: #f9fafb;
  }
`

export const DropZoneText = styled.span`
  font-size: 0.8rem;
  color: #6b7280;
`

export const HiddenInput = styled.input`
  display: none;
`

export const AttachmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const PrototypeCard = styled.div`
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 0.625rem 0.875rem;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  transition: all 0.15s ease;

  &:hover {
    border-color: #d1d5db;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }
`

export const PrototypeIconBox = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 0.5rem;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #4b5563;
`

export const PrototypeMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  flex: 1;
  min-width: 0;
`

export const PrototypeTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
`

export const PrototypeSubtitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  color: #6b7280;
  line-height: 1.2;
`

export const InlineExpInput = styled.input`
  font-size: 0.75rem;
  padding: 0.1rem 0.4rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  color: #374151;
  outline: none;
  width: 130px;
  height: 24px;
  background: #ffffff;

  &:focus {
    border-color: #2563eb;
  }
`

export const StatusBadge = styled.span<{ variant: 'vencido' | 'valido' }>`
  font-size: 0.625rem;
  font-weight: 700;
  padding: 0.15rem 0.6rem;
  border-radius: 9999px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  flex-shrink: 0;
  background-color: ${({ variant }) => (variant === 'vencido' ? '#FEE2E2' : '#DCFCE7')};
  color: ${({ variant }) => (variant === 'vencido' ? '#DC2626' : '#16A34A')};
`

export const CircularButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s ease;

  &:hover {
    border-color: #9ca3af;
    background: #f9fafb;
    color: #111827;
  }
`

export const CircularRemoveButton = styled(CircularButton)`
  &:hover {
    border-color: #fca5a5;
    background: #fef2f2;
    color: #dc2626;
  }
`

export const TitleInput = styled.input`
  font-size: 0.8125rem;
  color: #111827;
  font-weight: 700;
  border: 1px solid #0090D3;
  border-radius: 0.3rem;
  padding: 0.1rem 0.35rem;
  outline: none;
  width: 100%;
  font-family: inherit;
`
